import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { BehaviorSubject, Subject, Subscription, map, tap } from "rxjs";
import { ApplicationService } from "src/app/services/application.service";
import { AuthService } from "src/app/services/auth.service";
import { MyUtils } from "src/app/services/my-utils.service";
import { ActionDialogComponent } from "src/app/shared/dialogs/action-dialog/action-dialog.component";

@Component({
  selector: "app-top-bar",
  templateUrl: "./top-bar.component.html",
  styleUrls: ["./top-bar.component.scss"],
   encapsulation: ViewEncapsulation.None

})
export class TopBarComponent implements OnInit {
  // logo = '../../../assets/bg_image/focus-logo.png'

  readonly sub = new Subscription();

  @Input() logo = "";
  languages: any[] = []
  languagesBk: any[] = [
    { flag: "../../../assets/svg/flags/nl.svg", value: "nl-NL", viewValue: "Dutch" },
    { flag: "../../../assets/svg/flags/be.svg", value: "nl-BE", viewValue: "Dutch" },
    { flag: "../../../assets/svg/flags/gb.svg", value: "en-GB", viewValue: "English" },
    { flag: "../../../assets/svg/flags/fr.svg", value: "fr-FR", viewValue: "French" },
    { flag: "../../../assets/svg/flags/be.svg", value: "fr-BE", viewValue: "French" },
    { flag: "../../../assets/svg/flags/de.svg", value: "de-DE", viewValue: "Deutsch" },
    { flag: "../../../assets/svg/flags/at.svg", value: "at-AT", viewValue: "Austria" },

    { flag: "../../../assets/svg/flags/pt.svg", value: "pt-PT", viewValue: "Portuguese" },
    { flag: "../../../assets/svg/flags/it.svg", value: "it-IT", viewValue: "Italian" },
    { flag: "../../../assets/svg/flags/jp.svg", value: "jp-JP", viewValue: "Japanese" },
    { flag: "../../../assets/svg/flags/kr.svg", value: "kr-KR", viewValue: "Korean" },
    { flag: "../../../assets/svg/flags/pl.svg", value: "pl-PL", viewValue: "Polish" },
    { flag: "../../../assets/svg/flags/es.svg", value: "es-ES", viewValue: "Spanish" },

    { flag: "../../../assets/svg/flags/ar.svg", value: "es-AR", viewValue: "Spanish" },
    { flag: "../../../assets/svg/flags/tch.svg", value: "zh-ZH", viewValue: "Traditional_Chinese" },
    { flag: "../../../assets/svg/flags/vt.svg", value: "vi-VI", viewValue: "Vietnamese" },
    { flag: "../../../assets/svg/flags/arr.svg", value: "ar-SA", viewValue: "Arabic" },
    { flag: "../../../assets/svg/flags/br.svg", value: "pt-BR", viewValue: "Portuguese" },
    { flag: "../../../assets/svg/flags/pk.svg", value: "ur-UR", viewValue: "Urdu" },
    { flag: "../../../assets/svg/flags/tr.svg", value: "tr-TR", viewValue: "Turkish" },

    { flag: "../../../assets/svg/flags/hu.svg", value: "hu-HU", viewValue: "Hungarian" },
    { flag: "../../../assets/svg/flags/si.svg", value: "sl-SL", viewValue: "Slovenian" },
    { flag: "../../../assets/svg/flags/hr.svg", value: "hr-HR", viewValue: "Croatian" },
    { flag: "../../../assets/svg/flags/ua.svg", value: "uk-UA", viewValue: "Ukrainian" },


    // 
    // { flag: "../../../assets/svg/flags/keys.svg", value: "key-KEY", viewValue: "Keys" }
    // 
  ];
  username: string = "";


  selectLang: FormControl = new FormControl(
    this.languagesBk.find((t) => t.value === this.applicationService.languageSelectValue)
  );
  eReputationManagement = false;
  eReputationPayment: any;
  subscribe: any;
  constructor(
    public utils: MyUtils,
    private router: Router,
    public dialog: MatDialog,
    public authService: AuthService,
    public applicationService: ApplicationService
  ) { }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  ngOnInit() {
    this.languages = this.languagesBk
    if (this.applicationService.languageSelectValue === 'key-KEY') {
      this.selectLang.setValue(this.languagesBk.find((t) => t.value === 'en-GB'))
    }
    this.sub.add(this.applicationService.openEReputationSubject.subscribe((data) => {
      this.eReputationManagement = data.eReputationManagement
      this.eReputationPayment = data.eReputationPayment
    }));
    this.logo = this.authService.meSelectValue?.brand || this.logo;
    this.sub.add(this.authService.me$.subscribe((data) => {
      if (data) {
        this.logo = data.brand;

        if (data.roles.includes('TRANSLATE_ON') && !this.languages.find(el => el.value === 'key-KEY')) {

          this.languages = this.languagesBk
          this.languages.push({ flag: "../../../assets/svg/flags/keys.svg", value: "key-KEY", viewValue: "Keys" },)

        } else {
          this.languages = this.languagesBk
        }
        this.orderLanguages();

        //this.applicationService.setLanguageValue(data.defaultLocale);
      }

      // this.selectLang.setValue(data.defaultLocale)
    }));

    this.sub.add(this.selectLang.valueChanges.subscribe((data) => {
      this.applicationService.setLanguageValue(data.value);
    }));

    this.sub.add(this.applicationService.translationListSelect.subscribe(_ => {
      this.orderLanguages();
    }));

    /*if(this.authService.meSelectValue?.email!= "" && this.authService.meSelectValue?.email!= undefined && this.authService.meSelectValue?.email!= null){
      this.emailTemp = this.authService.meSelectValue?.email|| "";
      localStorage.setItem("emailTemp", this.emailTemp);
    }
    
    if(localStorage.getItem("emailTemp")!= "" && localStorage.getItem("emailTemp")!=null){
        this.emailLocalStorage = localStorage.getItem("emailTemp")!;
        if(this.emailLocalStorage.includes("@") && this.emailLocalStorage.split("@")[1].includes("stellantis")) {
          this.username = this.emailLocalStorage.split("@")[0];
        }
    } else {
      this.username = "";
    }*/
    let emailLocalStorage: string = "";
    if (localStorage.getItem("email") != "" && localStorage.getItem("email") != null && localStorage.getItem("email") != undefined) {
      emailLocalStorage = localStorage.getItem("email")!;
      if (emailLocalStorage.includes("@") && emailLocalStorage.split("@")[1].includes("stellantis")) {
        this.username = emailLocalStorage.split("@")[0];
      } else if (!emailLocalStorage.includes("@")) {
        this.username = emailLocalStorage;
      }
    } else {
      this.username = "";
    }

  }

  returnEReputation() {
    this.router.navigate(["/e-reputation"])
  }


  routerManagement() {
    this.router.navigate(["/e-reputation/management"])

  }

  orderLanguages() {
    this.languages.sort((lang1, lang2) => {
      let translatedLang1 = this.utils.traslatei18n(lang1.viewValue, 'language_key');
      let translatedLang2 = this.utils.traslatei18n(lang2.viewValue, 'language_key');
      return translatedLang1.localeCompare(translatedLang2);
    });
  }

  openDialog(enterAnimationDuration: string, exitAnimationDuration: string) {
    this.dialog.open(ActionDialogComponent, {
      width: "400px",
      enterAnimationDuration,
      exitAnimationDuration,
      data: {
        title: "attention",
        question: "areYouSure",
        yes: "yes",
        no: "no",
      },
    });
  }

  protected readonly screen = screen;
}
